import { useMemo } from 'react';

import column, { defaultColumn, defaultActionsColumn, defaultColumnId, deleteAction, editAction, defaultActiveColumn } from '@Components/Grid/utils/column';

import CostModeFormatter from '../../../../components/Grid/useColumns/CostModeFormatter';
import PayoutFormatter from '../../../../components/Grid/useColumns/PayoutFormatter';
import ThrottlingFormatter from '../../../../components/Grid/useColumns/ThrottlingFormatter';

export default function useColumns() {
  return useMemo(() => [
    defaultColumnId(),
    defaultColumn('subid'),
    column.accessor('cost_mode', {
      header: 'Cost Mode',
      cell: info => <CostModeFormatter info={info} />,
    }),
    column.accessor('payout', {
      header: 'Payout',
      cell: info => <PayoutFormatter info={info} />,
    }),
    column.accessor('mobile_payout', {
      header: 'Mobile Payout',
      cell: info => <PayoutFormatter info={info} />,
    }),
    column.accessor('scrub_percent', {
      header: 'Throttling Method',
      cell: info => <ThrottlingFormatter info={info} />,
    }),
    defaultActiveColumn(),
    defaultActionsColumn(editAction, deleteAction),
  ], [])
}
